import axios from 'axios';
import { configRefs } from '@utils/constants';

async function createRevisionRequest(user, revision) {
  if (!user || !user.institution?.id) {
    throw new Error("createRevisionRequest(): missing user data");
  }
  const res = await axios.post(`${await configRefs.apis.userdata.get()}/api/CourseRevisions/`, {
    userID: user.id,
    userInstitutionID: user.institution.id,
    courseID: revision.courseId,
    portalID: revision.portalId,
    title: revision.name,
    content: JSON.stringify(revision.disabledContentIds)
  });
  return {
    ...revision,
    id: res.data.objectID,
    isActive: true,
    __syncedWithBackend: true
  };
}

export { createRevisionRequest };
//# sourceMappingURL=request.create.js.map
